import { apiClient } from "../apiClient";

export const LOAI_CHUNG_CHI_ENDPOINT = "loai-chung-chi";
export const loaiChungChiApi = {
    SelectAll: () => apiClient.get(`${LOAI_CHUNG_CHI_ENDPOINT}`),
    Insert: (payload: any) => apiClient.post(`${LOAI_CHUNG_CHI_ENDPOINT}`, payload),
    Update: (id: number, payload: any) => apiClient.put(`${LOAI_CHUNG_CHI_ENDPOINT}/${id}`, payload),
    Delete: (id: number) => apiClient.delete(`${LOAI_CHUNG_CHI_ENDPOINT}/${id}`)
};